import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { Breadcrumb, BreadcrumbsService } from 'src/app/services/utils/breadcrumbs.service';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
  selector: 'app-menu-location',
  templateUrl: './menu-location.component.html',
  styleUrls: ['./menu-location.component.scss']
})
export class MenuLocationComponent implements OnInit, OnDestroy {

  subscription: Subscription;
  breadcrumbs: Array<Breadcrumb>;

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private breadcrumbsService: BreadcrumbsService) {
  }

  ngOnInit() {
    this.subscription = this.breadcrumbsService.getBreadcrumbs().subscribe(message => {
      if (message) {
        this.breadcrumbs = message.breadcrumbs;
      }
    });

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
